<template>
  <v-footer dark padless class=" justify-center d-flex flex-column">
    <div class="pl-3">
      <img
          class="logo-home"
          :style="{width:'300px'}"
          src="@/assets/img/LogoTremendas7.png"
      />
    </div>

    <div>
      <v-btn v-for="socialNetwork in getSocialNetworks"
             :key="socialNetwork.icon"
             :href="socialNetwork.link"
             target="_blank"
             class="mx-4"
             text
      >
        <v-icon size="24px" left>
          {{ socialNetwork.icon }}
        </v-icon>
        {{ socialNetwork.name }}
      </v-btn>
    </div>


    <div class="text-center py-4">
      <v-list-item>
        <v-list-item-content class="py-0">
          <v-list-item-subtitle>Dirección</v-list-item-subtitle>
          <v-list-item-title>Quesada 1625, CABA</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content class="py-0">
          <v-list-item-subtitle>Teléfono</v-list-item-subtitle>
          <v-list-item-title>15 5045 6440</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

    </div>

    <div class="pt-4">
      <a class="white--text" target="_blank" href="/img/InstructivoCongeladas.jpg">Como hornear congeladas</a>
    </div>


    <div style="width: 100%" class="mt-3 pb-2 text-center">
      <v-divider class="py-2"></v-divider>
      {{ new Date().getFullYear() }} <strong>@EmpanadasTremendas</strong>
    </div>

  </v-footer>
</template>

<script>

export default {
  name: "TheFooter",
  data: () => ({
    socialNetworks: [
      {
        icon: 'mdi-twitter',
        name: 'twitter',
        link: ''
      },
      {
        icon: 'mdi-facebook',
        name: 'facebook',
        link: ''
      },
      {
        icon: 'mdi-instagram',
        name: 'instagram',
        link: 'https://www.instagram.com/empanadastremendas/'
      }


    ],
  }),
  computed: {
    getSocialNetworks() {
      return this.socialNetworks.filter(v => v.link)
    }
  }
}
</script>

<style scoped>

</style>
